module.exports = __webpack_public_path__ + "static/img/1.df21ad1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/1.png
// module id = T9C/
// module chunks = 0